module.exports = __webpack_public_path__ + "img/1F927.0d1de445.svg";